import React, { useEffect, useState, useCallback } from "react";
import { environment } from "environments/environment";
import { SelectCustom } from "../../../Select";
import { useCreditSelector } from "../../../../stores/product/product.store";
import { CreditState } from "../../../../stores/credit/credit-state.interface";
import { useCreditDispatch } from "../../../../stores/credit/credit.store";
import { setShipping } from "../../../../stores/credit/credit.reducer";
import { PickupInterface } from "../../../../interfaces/credit/shipping-method.interface";
import { fetchTotalThunk } from "../../../../stores/credit/thunks/fetch-total.thunk";

interface RrProps {
    pickups: PickupInterface[]
}

export const Rr: React.FC<RrProps> = ({ pickups }) => {
    const translateText = useCreditSelector((state: CreditState) => state.text);
    const dispatch = useCreditDispatch();
    const [selectedPickup, setSelectedPickup] = useState<{ label: string; value: string } | null>(null);

    const onChangePickup = (option: { label: string; value: string } | null) => {
        setSelectedPickup(option);
        dispatch(setShipping(
            {
                zone: '',
                cityId: '',
                pickup: option!.value,
            }
        ));
        dispatch(fetchTotalThunk());
    };

    return (
        <div>
            <div>
                <label htmlFor="region" className="text-sm font-medium mb-3 block text-black">{ translateText.region }</label>
                <SelectCustom options={ pickups.map(p => ({ label: p.name, value: p.code })) } onChange={ onChangePickup } value={ selectedPickup } />
            </div>
        </div>
    );
};
